import { unscrambleId } from './url';

const normalizeIndustryId = (id: string) => unscrambleId(id).split('-')[0];

export const getStaticIndustryKey = (id: string): string => {
  switch (normalizeIndustryId(id)) {
    case '10000':
      return 'INDUSTRY_10000';
    case '100000':
      return 'INDUSTRY_100000';
    case '10100':
      return 'INDUSTRY_10100';
    case '10200':
      return 'INDUSTRY_10200';
    case '10300':
      return 'INDUSTRY_10300';
    case '10400':
      return 'INDUSTRY_10400';
    case '10500':
      return 'INDUSTRY_10500';
    case '110000':
      return 'INDUSTRY_110000';
    case '110100':
      return 'INDUSTRY_110100';
    case '110200':
      return 'INDUSTRY_110200';
    case '110300':
      return 'INDUSTRY_110300';
    case '110400':
      return 'INDUSTRY_110400';
    case '110500':
      return 'INDUSTRY_110500';
    case '110600':
      return 'INDUSTRY_110600';
    case '110700':
      return 'INDUSTRY_110700';
    case '120000':
      return 'INDUSTRY_120000';
    case '120100':
      return 'INDUSTRY_120100';
    case '120200':
      return 'INDUSTRY_120200';
    case '120300':
      return 'INDUSTRY_120300';
    case '120400':
      return 'INDUSTRY_120400';
    case '130000':
      return 'INDUSTRY_130000';
    case '140000':
      return 'INDUSTRY_140000';
    case '140100':
      return 'INDUSTRY_140100';
    case '140200':
      return 'INDUSTRY_140200';
    case '140300':
      return 'INDUSTRY_140300';
    case '150000':
      return 'INDUSTRY_150000';
    case '150100':
      return 'INDUSTRY_150100';
    case '150200':
      return 'INDUSTRY_150200';
    case '150300':
      return 'INDUSTRY_150300';
    case '160000':
      return 'INDUSTRY_160000';
    case '170000':
      return 'INDUSTRY_170000';
    case '170100':
      return 'INDUSTRY_170100';
    case '170200':
      return 'INDUSTRY_170200';
    case '170300':
      return 'INDUSTRY_170300';
    case '170400':
      return 'INDUSTRY_170400';
    case '170500':
      return 'INDUSTRY_170500';
    case '180000':
      return 'INDUSTRY_180000';
    case '180100':
      return 'INDUSTRY_180100';
    case '180200':
      return 'INDUSTRY_180200';
    case '190000':
      return 'INDUSTRY_190000';
    case '190100':
      return 'INDUSTRY_190100';
    case '190200':
      return 'INDUSTRY_190200';
    case '190300':
      return 'INDUSTRY_190300';
    case '190400':
      return 'INDUSTRY_190400';
    case '190500':
      return 'INDUSTRY_190500';
    case '190600':
      return 'INDUSTRY_190600';
    case '20000':
      return 'INDUSTRY_20000';
    case '200000':
      return 'INDUSTRY_200000';
    case '200100':
      return 'INDUSTRY_200100';
    case '200200':
      return 'INDUSTRY_200200';
    case '200300':
      return 'INDUSTRY_200300';
    case '200400':
      return 'INDUSTRY_200400';
    case '200500':
      return 'INDUSTRY_200500';
    case '200600':
      return 'INDUSTRY_200600';
    case '20100':
      return 'INDUSTRY_20100';
    case '20200':
      return 'INDUSTRY_20200';
    case '20300':
      return 'INDUSTRY_20300';
    case '20400':
      return 'INDUSTRY_20400';
    case '20500':
      return 'INDUSTRY_20500';
    case '20600':
      return 'INDUSTRY_20600';
    case '20700':
      return 'INDUSTRY_20700';
    case '20800':
      return 'INDUSTRY_20800';
    case '20900':
      return 'INDUSTRY_20900';
    case '21000':
      return 'INDUSTRY_21000';
    case '210000':
      return 'INDUSTRY_210000';
    case '210100':
      return 'INDUSTRY_210100';
    case '210200':
      return 'INDUSTRY_210200';
    case '210300':
      return 'INDUSTRY_210300';
    case '210400':
      return 'INDUSTRY_210400';
    case '210500':
      return 'INDUSTRY_210500';
    case '210600':
      return 'INDUSTRY_210600';
    case '210700':
      return 'INDUSTRY_210700';
    case '210800':
      return 'INDUSTRY_210800';
    case '21100':
      return 'INDUSTRY_21100';
    case '21200':
      return 'INDUSTRY_21200';
    case '220000':
      return 'INDUSTRY_220000';
    case '220100':
      return 'INDUSTRY_220100';
    case '220200':
      return 'INDUSTRY_220200';
    case '220300':
      return 'INDUSTRY_220300';
    case '220400':
      return 'INDUSTRY_220400';
    case '220500':
      return 'INDUSTRY_220500';
    case '220600':
      return 'INDUSTRY_220600';
    case '220700':
      return 'INDUSTRY_220700';
    case '220800':
      return 'INDUSTRY_220800';
    case '230000':
      return 'INDUSTRY_230000';
    case '230100':
      return 'INDUSTRY_230100';
    case '230200':
      return 'INDUSTRY_230200';
    case '230300':
      return 'INDUSTRY_230300';
    case '230400':
      return 'INDUSTRY_230400';
    case '230500':
      return 'INDUSTRY_230500';
    case '230600':
      return 'INDUSTRY_230600';
    case '230700':
      return 'INDUSTRY_230700';
    case '230800':
      return 'INDUSTRY_230800';
    case '30000':
      return 'INDUSTRY_30000';
    case '30100':
      return 'INDUSTRY_30100';
    case '30200':
      return 'INDUSTRY_30200';
    case '30300':
      return 'INDUSTRY_30300';
    case '30400':
      return 'INDUSTRY_30400';
    case '30500':
      return 'INDUSTRY_30500';
    case '30600':
      return 'INDUSTRY_30600';
    case '40000':
      return 'INDUSTRY_40000';
    case '40100':
      return 'INDUSTRY_40100';
    case '40200':
      return 'INDUSTRY_40200';
    case '40300':
      return 'INDUSTRY_40300';
    case '40400':
      return 'INDUSTRY_40400';
    case '40500':
      return 'INDUSTRY_40500';
    case '40600':
      return 'INDUSTRY_40600';
    case '40700':
      return 'INDUSTRY_40700';
    case '40800':
      return 'INDUSTRY_40800';
    case '40900':
      return 'INDUSTRY_40900';
    case '41000':
      return 'INDUSTRY_41000';
    case '41100':
      return 'INDUSTRY_41100';
    case '41200':
      return 'INDUSTRY_41200';
    case '41300':
      return 'INDUSTRY_41300';
    case '50000':
      return 'INDUSTRY_50000';
    case '50100':
      return 'INDUSTRY_50100';
    case '50200':
      return 'INDUSTRY_50200';
    case '60000':
      return 'INDUSTRY_60000';
    case '60100':
      return 'INDUSTRY_60100';
    case '60200':
      return 'INDUSTRY_60200';
    case '60300':
      return 'INDUSTRY_60300';
    case '60400':
      return 'INDUSTRY_60400';
    case '60500':
      return 'INDUSTRY_60500';
    case '70000':
      return 'INDUSTRY_70000';
    case '70100':
      return 'INDUSTRY_70100';
    case '70200':
      return 'INDUSTRY_70200';
    case '70300':
      return 'INDUSTRY_70300';
    case '70400':
      return 'INDUSTRY_70400';
    case '70500':
      return 'INDUSTRY_70500';
    case '70600':
      return 'INDUSTRY_70600';
    case '80000':
      return 'INDUSTRY_80000';
    case '80100':
      return 'INDUSTRY_80100';
    case '80200':
      return 'INDUSTRY_80200';
    case '80300':
      return 'INDUSTRY_80300';
    case '80400':
      return 'INDUSTRY_80400';
    case '90000':
      return 'INDUSTRY_90000';
    case '90100':
      return 'INDUSTRY_90100';
    case '90200':
      return 'INDUSTRY_90200';
    case '90300':
      return 'INDUSTRY_90300';
    case '90400':
      return 'INDUSTRY_90400';
    case '90500':
      return 'INDUSTRY_90500';
    case '90600':
      return 'INDUSTRY_90600';
    case '90700':
      return 'INDUSTRY_90700';
    case '90800':
      return 'INDUSTRY_90800';
    default:
      return `INDUSTRY_${normalizeIndustryId(id)}`;
  }
};
